import { render, staticRenderFns } from "./xxzph.vue?vue&type=template&id=484ce1ff&scoped=true&"
import script from "./xxzph.vue?vue&type=script&lang=js&"
export * from "./xxzph.vue?vue&type=script&lang=js&"
import style0 from "./xxzph.vue?vue&type=style&index=0&id=484ce1ff&prod&lang=less&"
import style1 from "./xxzph.vue?vue&type=style&index=1&id=484ce1ff&prod&lang=less&scoped=true&"
import style2 from "./xxzph.vue?vue&type=style&index=2&id=484ce1ff&prod&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ce1ff",
  null
  
)

export default component.exports